module.exports = __webpack_public_path__ + "static/media/main_aboutus_1.83043a17.png";